module.exports = __webpack_public_path__ + "img/redlock-ssl-365days.ccfa1aec.jpg";